export interface TimeTrackingEmployee {
	employeeId: string;
	canSeeEmployee: boolean;
	preferredName: string;
	lastName: string;
	displayName: string;
	hasFutureStartDate: boolean;
	startsOnString: string;
	configurationName: string;
	location: string;
	hasLocation: boolean;
	overtimeState: string;
	startDate: string;
	inOvertimeCountry: boolean;
	overtimeCountryISO: string;
	isOvertimeExempt: boolean;
	paySchedule: string;
	hasPaySchedule: boolean;
	clockInId: string;
}

export enum ClockInIdType {
	RANDOM_NUMBER = 'random',
	EMPLOYEE_NUMBER = 'employee_number',
}
